// Central registry of option constructors
import TextAnswerOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/text-answer"
import AcknowledgmentOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/acknowledgment"
import AssetOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/asset"
import AssetFieldOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/asset-field"
import AssignmentFieldOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/assignment-field"
import AudioOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/audio"
import BarcodeOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/barcode"
import CalculationOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/calculation"
import CheckboxOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/checkbox"
import ConstantOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/constant"
import CounterOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/counter"
import DatasetOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/dataset"
import DateTimeOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/datetime"
import DocumentIdOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/document-id"
import DropdownOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/dropdown"
import EndPageOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/end-page"
import EndSignatureOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/end-signature"
import FileManagerOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/file-manager"
import GlobalEndPageOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-end-page"
import StartPageOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/start-page"
import SiteOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/site"
import GlobalItemOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-item"
import GlobalItemsOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-items"
import GlobalListOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-list"
import GlobalPageOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-page"
import GlobalSectionOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-section"
import GlobalStartPageOptionsVM
  from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-start-page"
import HiddenPageOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/hidden-page"
import InspectionEndDateOptionsVM
  from "@cmodules/checklist/assets/data/types/vm/template-builder/types/inspection-end-date"
import InspectionLocationOptionsVM
  from "@cmodules/checklist/assets/data/types/vm/template-builder/types/inspection-location"
import InspectionNumberOptionsVM
  from "@cmodules/checklist/assets/data/types/vm/template-builder/types/inspection-number"
import InspectionRealEndDateOptionsVM
  from "@cmodules/checklist/assets/data/types/vm/template-builder/types/inspection-real-end-date"
import InspectionRealStartDateOptionsVM
  from "@cmodules/checklist/assets/data/types/vm/template-builder/types/inspection-real-start-date"
import InspectionStartDateOptionsVM
  from "@cmodules/checklist/assets/data/types/vm/template-builder/types/inspection-start-date"
import InstructionOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/instruction"
import IssuesCountOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/issues-count"
import ListOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/list"
import LongTextOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/long-text"
import NumberOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/number"
import PageOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/page"
import PersonOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/person"
import PhotoOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/photo"
import QrOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/qr"
import RepeatingGroupOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/repeating-group"
import SectionOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/section"
import SignatureOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/signature"
import SliderOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/slider"
import SparePartsOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/spare-parts"
import SwitchOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/switch"
import UrlOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/url"
import VideoOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/video"
import YesNoOptionsVM from "@cmodules/checklist/assets/data/types/vm/template-builder/types/yesno"

export const OptionsRegistry = {
  acknowledgment: AcknowledgmentOptionsVM,
  asset: AssetOptionsVM,
  asset_field: AssetFieldOptionsVM,
  assignment_field: AssignmentFieldOptionsVM,
  audio: AudioOptionsVM,
  barcode: BarcodeOptionsVM,
  calculation: CalculationOptionsVM,
  checkbox: CheckboxOptionsVM,
  constant: ConstantOptionsVM,
  counter: CounterOptionsVM,
  dataset: DatasetOptionsVM,
  datetime: DateTimeOptionsVM,
  document_id: DocumentIdOptionsVM,
  dropdown: DropdownOptionsVM,
  end_page: EndPageOptionsVM,
  end_signature: EndSignatureOptionsVM,
  file_manager: FileManagerOptionsVM,
  global_end_page: GlobalEndPageOptionsVM,
  global_item: GlobalItemOptionsVM,
  global_items: GlobalItemsOptionsVM,
  global_list: GlobalListOptionsVM,
  global_page: GlobalPageOptionsVM,
  global_section: GlobalSectionOptionsVM,
  global_start_page: GlobalStartPageOptionsVM,
  hidden_page: HiddenPageOptionsVM,
  inspection_end_date: InspectionEndDateOptionsVM,
  inspection_location: InspectionLocationOptionsVM,
  inspection_number: InspectionNumberOptionsVM,
  inspection_real_end_date: InspectionRealEndDateOptionsVM,
  inspection_real_start_date: InspectionRealStartDateOptionsVM,
  inspection_start_date: InspectionStartDateOptionsVM,
  instruction: InstructionOptionsVM,
  issues_count: IssuesCountOptionsVM,
  list: ListOptionsVM,
  longText: LongTextOptionsVM,
  number: NumberOptionsVM,
  page: PageOptionsVM,
  person: PersonOptionsVM,
  photo: PhotoOptionsVM,
  qr: QrOptionsVM,
  repeating_group: RepeatingGroupOptionsVM,
  section: SectionOptionsVM,
  signature: SignatureOptionsVM,
  site: SiteOptionsVM,
  slider: SliderOptionsVM,
  spare_parts: SparePartsOptionsVM,
  start_page: StartPageOptionsVM,
  switch: SwitchOptionsVM,
  textAnswer: TextAnswerOptionsVM,
  url: UrlOptionsVM,
  video: VideoOptionsVM,
  yesno: YesNoOptionsVM
} as const
export { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
export {
  AcknowledgmentOptionsVM,
  AssetOptionsVM,
  AssetFieldOptionsVM,
  AssignmentFieldOptionsVM,
  AudioOptionsVM,
  BarcodeOptionsVM,
  CalculationOptionsVM,
  CheckboxOptionsVM,
  ConstantOptionsVM,
  CounterOptionsVM,
  DatasetOptionsVM,
  DateTimeOptionsVM,
  DocumentIdOptionsVM,
  DropdownOptionsVM,
  EndPageOptionsVM,
  EndSignatureOptionsVM,
  FileManagerOptionsVM,
  GlobalEndPageOptionsVM,
  GlobalItemOptionsVM,
  GlobalItemsOptionsVM,
  GlobalListOptionsVM,
  GlobalPageOptionsVM,
  GlobalSectionOptionsVM,
  GlobalStartPageOptionsVM,
  HiddenPageOptionsVM,
  InspectionEndDateOptionsVM,
  InspectionLocationOptionsVM,
  InspectionNumberOptionsVM,
  InspectionRealEndDateOptionsVM,
  InspectionRealStartDateOptionsVM,
  InspectionStartDateOptionsVM,
  InstructionOptionsVM,
  IssuesCountOptionsVM,
  ListOptionsVM,
  LongTextOptionsVM,
  NumberOptionsVM,
  PageOptionsVM,
  PersonOptionsVM,
  PhotoOptionsVM,
  QrOptionsVM,
  RepeatingGroupOptionsVM,
  SectionOptionsVM,
  SignatureOptionsVM,
  SiteOptionsVM,
  SliderOptionsVM,
  SparePartsOptionsVM,
  StartPageOptionsVM,
  SwitchOptionsVM,
  TextAnswerOptionsVM,
  UrlOptionsVM,
  VideoOptionsVM,
  YesNoOptionsVM
}